<template>
  <div>
    <div class="d-flex mb-4">
      <label v-if="!concedente"> Nenhum concedente selecionado </label>
      <div v-else class="w-100">
        <b-row>
          <b-col cols="2">
            <img
              :src="image_concedente"
              :alt="concedente ? concedente.nome : 'Concedente'"
              class="file-img-concedente"
            />
          </b-col>
          <b-col>
            <b-row>
              <b-col class="mb-3"> {{ concedente.nome }}</b-col>
            </b-row>
            <b-row>
              <b-col>
                <CellEndereco :endereco="concedente.endereco" />
              </b-col>
              <b-col>
                <CellContatos :contatos="concedente.contatos" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-button
        variant=""
        size="sm"
        class="ml-auto"
        v-b-modal.modal-list-concedente
        >Selecionar um Concedente</b-button
      >
    </div>
    <div v-if="concedente">
      <div class="w-75 mr-auto mb-2">
        <b-input-group size="sm">
          <b-form-input
            v-model="termo_pesquisa"
            v-on:keydown.enter="searchTerm"
            placeholder="Pesquisar"
          ></b-form-input>
          <b-input-group-append>
            <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <b-table
        :key="tableKey"
        striped
        hover
        :items="rows"
        :fields="fields"
        :busy="is_loading"
        show-empty
      >
        <template #head(select)>
          <b-form-checkbox
            v-model="allSelected"
            :indeterminate="indeterminate"
            @change="toggleAll"
          />
        </template>
        <template #cell(select)="{ item }">
          <b-form-checkbox v-model="selecionados" :value="item.id" />
        </template>
        <template #cell(nome)="{ item }">
          {{ item.nome }}<br />
          <small class="text-muted">{{ item.funcao }}</small>
        </template>
        <template #cell(endereco)="{ item }">
          <CellEndereco :endereco="item.endereco" />
        </template>
        <template #cell(contatos)="{ item }">
          <CellContatos v-if="item.contatos" :contatos="item.contatos" />
        </template>
        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
      <div class="mt-3">
        <pagination-nav
          :pagination="pagination"
          @input="loadConcedentesContatos()"
          :change_route="false"
        />
      </div>
    </div>

    <b-modal
      id="modal-list-concedente"
      ref="modal-list-concedente"
      title="Selecione um Concedente"
      size="xl"
      scrollable
      ok-only
      ok-title="Fechar"
      ok-variant="secundary"
    >
      <TableList actions="select" @selected="selectConcedente" />
    </b-modal>
  </div>
</template>

<script>
import TableList from "@/modules/concedentes/Components/TableList.vue";
import CellEndereco from "@/components/Table/CellEndereco.vue";
import CellContatos from "@/components/Table/CellContatos.vue";
import { mapActions, mapState } from "vuex";
import slugify from "@/helpers/functions/slugify";
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const noImage = require("@/assets/icones/no-image.png");
const props = makePropsConfigurable(
  sortKeys({
    value: {
      type: Array,
      default: [],
    },
    concedente_init: {
      type: Object,
      default: {},
    },
    placeholder: {
      type: String,
      default: "Nenhum município selecionado",
    },
  })
);

export default {
  components: { TableList, CellEndereco, CellContatos },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    concedente: null,
    concedente_contatos: [],
    selecionados: [],
    allSelected: false,
    indeterminate: false,
    concedente_imagem: "",
    termo_pesquisa: "",
    tableKey: 0,
  }),
  computed: {
    ...mapState("concedentes_contatos", [
      "concedentes_contatos",
      "pagination",
      "is_loading",
    ]),
    rows() {
      const termo = slugify(this.termo_pesquisa);
      const concedentes_contatos = this.concedentes_contatos.filter((v) => {
        var valid =
          slugify(v.nome).indexOf(termo) >= 0 ||
          slugify(v.funcao).indexOf(termo) >= 0;

        if (!valid && v.contatos && v.contatos.emails) {
          v.contatos.emails.forEach((email) => {
            valid = valid || slugify(email.value).indexOf(termo) >= 0;
          });
        }
        return valid;
      });

      return concedentes_contatos;
    },
    fields() {
      return [
        { key: "select", label: "#" },
        { key: "nome", label: "Nome" },
        { key: "endereco", label: "Endereço" },
        { key: "contatos", label: "Contatos" },
      ];
    },
    image_concedente() {
      return this.concedente && this.concedente.imagem
        ? this.concedente.imagem.url
        : noImage;
    },
  },
  methods: {
    ...mapActions("concedentes_contatos", [
      "ActionGetAll",
      "ActionShow",
      "ActionSetPagination",
    ]),
    ...mapActions("files", ["ActionGetImage"]),

    async selectConcedente(concedente) {
      if (!this.concedente || concedente.id != this.concedente.id) {
        this.concedente = concedente;
        this.selecionados = [];
        await this.ActionSetPagination({
          current_page: 1,
          per_page: this.pagination.per_page || 15,
        });
        await this.loadConcedentesContatos();
      }

      this.$emit("changeConcedente", this.concedente);
      this.$refs["modal-list-concedente"].hide();
    },
    async loadConcedentesContatos() {
      try {
        await this.ActionGetAll({
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          orderBy: "id",
          sortBy: "asc",
          q: this.termo_pesquisa,
          concedente_id: this.concedente.id,
        });
        this.tableKey += 1;
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    async searchTerm() {
      // reset to first page and fetch with current term
      await this.ActionSetPagination({
        current_page: 1,
        per_page: this.pagination.per_page || 15,
      });
      await this.loadConcedentesContatos();
    },
    toggleAll(checked) {
      this.selecionados = [];
      if (checked) {
        this.concedentes_contatos.forEach((item) => {
          this.selecionados.push(item.id);
        });
      }
    },
  },
  watch: {
    selecionados: function (value) {
      if (this.selecionados.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (
        this.selecionados.length === this.concedentes_contatos.length
      ) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }

      this.$emit("input", this.selecionados);
    },
    concedente_init: function (value, old) {
      if (value && value.id != old.id) {
        this.selectConcedente(value);
        this.selecionados = this.value;
      }
    },
  },
  async mounted() {
    if (this.concedente_init && this.concedente_init.id) {
      this.selectConcedente(this.concedente_init);
      this.selecionados = this.value;
    }
  },
};
</script>

<style lang="scss">
.file-img-concedente {
  width: 100%;
}
</style>
